import ObjectBlocker from "./ObjectBlocker";
import { ObjectSuperTypesEnum, SelectionTypeEnum } from "../../enums";

class Table extends ObjectBlocker {
  protected getIconSize(table: any): number {
    const shape = table.item(0);
    return Math.min(shape.width, shape.height) * 0.7;
  }

  protected getSelectionTargets(group: any): any[] {
    const isTable = group.superType === ObjectSuperTypesEnum.RoundTable || group.superType === ObjectSuperTypesEnum.RectTable;
    if (!isTable || group.selectionType !== SelectionTypeEnum.byTable) return [];
    return (group.getObjects("group") || []).filter((object: any) => object.superType === ObjectSuperTypesEnum.Table);
  }
}

export default Table;
